import { z } from 'zod'

import type { ZodSafeParseResult } from 'zod'

const period = z.string()

const columnSchemaDTO = z.object({
  Amount_to_invoice: z.string(),
  CRM_ID: z.string(),
  Currency: z.string(),
  Period: period,
  Product: z.string(),
})

const schema = z.object({
  data: z.record(z.string(), z.array(columnSchemaDTO)),
  total_count: z.number(),
})

export type ColumnSchemaDTO = z.infer<typeof columnSchemaDTO>
export type PeriodDTO = z.infer<typeof period>
export type SchemaDTO = z.infer<typeof schema>

export const parseFinanceData = (data: unknown): SchemaDTO => {
  const result: ZodSafeParseResult<SchemaDTO> = schema.safeParse(data)

  if (!result.success) {
    throw Error('Invalid data format for finance report.')
  } else {
    return result.data
  }
}
